import { ReactNode } from "react"

import { selectUserLeaderboardRank, useDappSelector } from "#/redux-state"
import { separateThousandsWithComaRegExp } from "#/shared/utils"

import StatsCard from "./StatsCard"

type StatsMatsRankCardProps = {
  label?: ReactNode
}

export default function StatsMatsRankCard({ label }: StatsMatsRankCardProps) {
  const { rank } = useDappSelector(selectUserLeaderboardRank)

  if (!rank) return null

  return (
    <StatsCard
      value={`#${separateThousandsWithComaRegExp(rank.toString())}`}
      title="Your rank"
      label={label}
    />
  )
}
